"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TypographyTypes = require("./TypographyTypes");

var _core = require("../../core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Typography = function Typography(_ref) {
  var _cn;

  var align = _ref.align,
      children = _ref.children,
      type = _ref.type,
      tag = _ref.tag,
      boldness = _ref.boldness,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  var getClassName = (0, _classNames["default"])(Typography.displayName);
  return /*#__PURE__*/_react["default"].createElement(tag, {
    className: (0, _classnames["default"])(className, getClassName({
      modifiers: (0, _classnames["default"])((_cn = {}, _defineProperty(_cn, type, true), _defineProperty(_cn, align, true), _defineProperty(_cn, boldness, Boolean(boldness)), _cn))
    }))
  }, children);
};

Typography.displayName = "Typography";
Typography.defaultProps = {
  tag: _TypographyTypes.TypographyTags.DIV,
  align: _core.Alignments.LEFT
};
var _default = Typography;
exports["default"] = _default;